'use client';

import ArticleDetail from '@/components/article-detail';
import { LicenseProcessBreadcrumbItems } from '@/data/globals.data';

export default function Client() {
  return (
    <ArticleDetail
      breadcrumbItems={LicenseProcessBreadcrumbItems}
      showStoryBanner
    />
  );
}
